import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
} from "reactstrap";
import { ResponsiveContainer, LineChart, Line } from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import TablaAulas from "./AlumnosList";
import privateActions from "../../../../../API/privateCalls/privateActions";
import {formatFloatString} from "../../../../../utils/helperMethods";
export default class MiniJuegos extends React.Component {
  state = {   loading: true,
    data: {},
    pageMiniJuegos: 0,
    sizeMiniJuegos: 10,
    pageAlumnos: 0,
    sizeAlumnos: 10,
    pageActividades: 0,
    sizeActividades: 10,
    listMiniJuegos: [],
    listaTabs: [],
    selectedAlumno:{},
    selectedTabKey: 0,
    selectedAula: {},
    listAlumnosAulasActive: [],
    selectedActivity: "",
    activityResponse: [],tiempoPromedio:0,loadingTiempo:true };

  componentDidMount() {
    this.loadMiniJuego()
    this.loadMiniJuegosTiempoTotalPromedio()
  }



  //////////////////////////////CORDON START

  loadMiniJuegosTiempoTotalPromedio() {
    privateActions.elementosMinijuego(

      )
      .then((res) => {
        console.log("RES", res);
        this.setState({ tiempoPromedio: res, loadingTiempo: false });
      });
  }

  loadMiniJuego() {
    privateActions.sharedMinijuegos(
       
        this.state.pageMiniJuegos,
        this.state.sizeMiniJuegos
      )
      .then((res) => {
        console.log("RES", res);
        this.setState({ listMiniJuegos: res, loading: false });
      });
  }

  paginateMiniJuego(direc) {
    if (direc > 0) {
      this.setState({ pageMiniJuegos: this.state.pageMiniJuegos + 1 }, () => {
        this.loadMiniJuego();
      });
    } else {
      this.setState(
        {
          pageMiniJuegos:
            this.state.pageMiniJuegos == 0
              ? this.state.pageMiniJuegos
              : this.state.pageMiniJuegos - 1,
        },
        () => {
          this.loadMiniJuego();
        }
      );
    }
  }




  ///////////////////////////////CORDON END


  render() {
    if (this.state.loading || this.state.loadingTiempo) return null;
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
          <Col md="12">
              <div className="card mb-3 widget-chart card-hover-shadow-2x">
                <div className="icon-wrapper border-light rounded-circle">
                  <div className="icon-wrapper-bg bg-light" />
                  <i className="pe-7s-timer icon-gradient bg-malibu-beach"> </i>
                </div>
                <div className="widget-numbers">{formatFloatString(this.state.tiempoPromedio)} Segundos</div>
                <div className="widget-subheading">Tiempo promedio total en mini juegos</div>
              </div>
            </Col>
        
          </Row>
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>Mini Juegos</CardTitle>
                  <TablaAulas
                    page={this.state.pageMiniJuegos}
                    paginate={(num) => this.paginateMiniJuego(num)}
                    data={this.state.listMiniJuegos}
                    onViewAula={(data) => this.handleSelectAula(data)}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}

const data = [
  {
    name: "Page A",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page B",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page C",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page D",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page E",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page F",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page G",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page C",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page D",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page E",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page F",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
  {
    name: "Page G",
    uv: Math.random() * 2000,
    pv: Math.random() * 2000,
    amt: Math.random() * 2000,
  },
];



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/elementosDelJuego/MiniJuegos-admin/component/MiniJuegos.js